import { useEffect, useState } from 'react'
import { useSubscribePayment } from './useSubscribePayment'
import { useSubscriptionsList } from './useSubscriptionsList'

type UseSubscribeFormOptions = {
    onSuccess?: () => void
}

export const useSubscribeForm = ({ onSuccess }: UseSubscribeFormOptions = {}) => {
    const { subscriptions, isLoading, error } = useSubscriptionsList()
    const { handleSubscribe, isPaying, isWidgetReady, paymentError } = useSubscribePayment({ onSuccess })
    const [selectedSubscriptionId, setSelectedSubscriptionId] = useState<string | null>(null)
    const [selectionError, setSelectionError] = useState<string | null>(null)

    const handleSubscriptionSelect = (subscriptionId: string) => {
        setSelectedSubscriptionId(subscriptionId)
        setSelectionError(null)
    }

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault()
        if (!selectedSubscriptionId) {
            setSelectionError('Пожалуйста, выберите тариф.')
            return
        }

        const selectedSubscription = subscriptions.find(plan => plan.id === selectedSubscriptionId)
        handleSubscribe(selectedSubscriptionId, {
            purchaseLabel: selectedSubscription?.name ?? 'Подписка',
            tokens: selectedSubscription?.tokens,
        })
    }

    useEffect(() => {
        if (subscriptions.length === 0) return
        if (selectedSubscriptionId) return
        setSelectedSubscriptionId(subscriptions[0].id)
    }, [selectedSubscriptionId, subscriptions])

    return {
        subscriptions,
        isLoading,
        loadError: error,
        selectedSubscriptionId,
        isPaying,
        isWidgetReady,
        resolvedError: selectionError ?? paymentError,
        handleSubscriptionSelect,
        handleSubmit,
    }
}
